(function () {
  const block = {
    $blocksDefault: document.querySelectorAll('.video_testimonials.template_default'),
    $blocksPpc: document.querySelectorAll('.video_testimonials.template_ppc'),
    init() {
      if (this.$blocksDefault.length && window.innerWidth > 768) {
        PubSub.publish('embla.init', {
          name: 'client-testimonials-default',
          $els: this.$blocksDefault,
          options: {
            loop: true,
            dragFree: false
          },
          plugins: [
            EmblaCarouselClassNames(),
            EmblaCarouselAutoplay({
              delay: 3000,
              playOnInit: false
            })
          ]
        });
      }

      this.setUpListeners();
    },

    setUpListeners() {
      this.$blocksDefault
        .forEach($block => {
          const $slider = $block.querySelector('.embla');

          if (window.innerWidth > 768) {
            $slider.addEventListener('mousemove', this.mouseMoveHandler.bind(this));

            $slider
              .querySelectorAll('.embla__slide')
              .forEach($slide => {
                $slide.addEventListener('mouseleave', this.mouseLeaveHandler.bind(this));
              });
          }

          $slider
            .querySelectorAll('.thumb_wrapper')
            .forEach($thumb => $thumb.addEventListener('click', this.initVideo.bind(this)));
        });

      this.$blocksPpc
        .forEach($block => {
          const $slider = $block.querySelector('.reviews');

          $slider
            .querySelectorAll('.thumb_wrapper')
            .forEach($thumb => $thumb.addEventListener('click', this.initVideo.bind(this)));
        });
    },

    mouseMoveHandler({clientX, clientY, target}) {
      const $slide = target.closest('.embla__slide.is-snapped:not(.opened)');

      if ($slide) {
        const $thumb = $slide.querySelector('.thumb_wrapper');
        const wrapperRect = $thumb.getBoundingClientRect();
        const $btn = $thumb.querySelector('.play_btn');
        let newX = (clientX - wrapperRect.x) / wrapperRect.width;
        let newY = (clientY - wrapperRect.y) / wrapperRect.height;
        newX -= 0.5;
        newY -= 0.5;
        newX *= wrapperRect.width;
        newY *= wrapperRect.height;

        if ($btn) {
          gsap.to($btn, {
            x: newX,
            y: newY,
            duration: 2,
            ease: 'expo.out'
          });
        }
      }
    },

    mouseLeaveHandler({currentTarget}) {
      const $slide = currentTarget;

      if ($slide) {
        const $btn = $slide.querySelector('.play_btn');

        if ($btn) {
          gsap.to($btn, {
            x: 0,
            y: 0,
            duration: 2,
            ease: 'expo.out'
          });
        }
      }
    },

    getYouTubeVideoId(url) {
      const match = url.match(/(?:youtube\.com\/(?:embed\/|.*[?&]v=)|youtu\.be\/)([^&?/]+)/);
      return match ? match[1] : null;
    },

    initVideo({currentTarget}) {
      const $slide = currentTarget.closest('.embla__slide:not(.opened), .review:not(.opened)');

      console.log($slide);

      if ((window.innerWidth > 768 && $slide && $slide.classList.contains('is-snapped'))
      || (window.innerWidth <= 768 && $slide)) {
        const videoHtmlStr = $slide.querySelector('script').textContent;
        const $videoWrapper = currentTarget.querySelector('.video_wrapper');
        let $modalEl;

        console.log($videoWrapper);

        $videoWrapper.innerHTML = videoHtmlStr;

        setTimeout(() => {
          $modalEl = $videoWrapper.querySelector('#player');

          if ($modalEl) {
            $modalEl.dataset.youtubeId = this.getYouTubeVideoId($modalEl.dataset.ytUrl);
          } else if ($videoWrapper.querySelector('.tjh_video')) {
            $modalEl = $videoWrapper.querySelector('.tjh_video');
          }

          PubSub.publish('modal.open', $modalEl);
        }, 10);
      } else if (window.innerWidth > 768 && $slide && !$slide.classList.contains('is-snapped')) {
        PubSub.publish('embla.slideTo', {
          $el: $slide
        });
      }
    }
  };

  block.init();
})();

